import { Facebook, Instagram, MapPin, Phone } from "lucide-react";
import { HOURS, SALON } from "@/data/salon";
import { Overline, Reveal } from "@/components/Reveal";

const Contact = () => (
    <section
        id="contatti"
        data-testid="contact-section"
        className="py-24 md:py-32 bg-sand"
    >
        <div className="max-w-[1440px] mx-auto px-5 md:px-10">
            <div className="grid lg:grid-cols-2 gap-14 lg:gap-24">
                <div>
                    <Reveal>
                        <Overline>Contatti & Prenotazioni</Overline>
                        <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink mt-4">
                            Prenota il tuo{" "}
                            <em className="italic text-rosegold">momento</em>
                        </h2>
                        <p className="mt-6 text-stone2 text-base md:text-lg leading-relaxed max-w-md">
                            Riceviamo su appuntamento — ma se hai un'urgenza, chiamaci:
                            troviamo quasi sempre uno spazio per te.
                        </p>
                    </Reveal>

                    <Reveal delay={0.1} className="mt-10">
                        <a
                            href={SALON.phoneHref}
                            data-testid="phone-link"
                            className="group block font-serif text-4xl md:text-6xl text-ink hover:text-sage transition-colors duration-300 leading-tight"
                        >
                            {SALON.phoneDisplay}
                            <span className="block mt-2 text-xs tracking-[0.25em] uppercase text-stone2 group-hover:text-sage transition-colors duration-300 font-sans">
                                Tocca per chiamare
                            </span>
                        </a>
                    </Reveal>

                    <Reveal delay={0.18} className="mt-8 flex flex-wrap gap-4">
                        <a
                            href={SALON.phoneHref}
                            data-testid="call-cta-button"
                            className="inline-flex items-center gap-3 bg-ink text-cream text-sm tracking-[0.1em] uppercase px-8 py-4 rounded-full hover:bg-sage transition-colors duration-300"
                        >
                            <Phone size={18} /> Chiama e prenota
                        </a>
                    </Reveal>

                    <Reveal delay={0.24} className="mt-10">
                        <div className="flex items-start gap-3 text-stone2">
                            <MapPin size={20} className="mt-1 shrink-0 text-sage" />
                            <p className="text-base md:text-lg">{SALON.address}</p>
                        </div>
                        <div className="mt-6 flex gap-4">
                            <a
                                href="#contatti"
                                aria-label="Instagram (in arrivo)"
                                title="Instagram — in arrivo"
                                data-testid="social-instagram"
                                className="w-11 h-11 rounded-full border border-linen flex items-center justify-center text-stone2 hover:text-rosegold hover:border-rosegold transition-colors duration-300"
                            >
                                <Instagram size={18} />
                            </a>
                            <a
                                href="#contatti"
                                aria-label="Facebook (in arrivo)"
                                title="Facebook — in arrivo"
                                data-testid="social-facebook"
                                className="w-11 h-11 rounded-full border border-linen flex items-center justify-center text-stone2 hover:text-rosegold hover:border-rosegold transition-colors duration-300"
                            >
                                <Facebook size={18} />
                            </a>
                            <span className="self-center text-xs tracking-[0.2em] uppercase text-stone2/60">
                                Social in arrivo
                            </span>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.12}>
                    <div
                        data-testid="hours-table"
                        className="border border-linen bg-cream p-7 md:p-10"
                    >
                        <h3 className="font-serif text-2xl md:text-3xl text-ink mb-6">
                            Orari di apertura
                        </h3>
                        <dl className="divide-y divide-linen">
                            {HOURS.map((h) => (
                                <div
                                    key={h.day}
                                    className="flex items-baseline justify-between gap-4 py-3.5"
                                    data-testid={`hours-row-${h.day.toLowerCase()}`}
                                >
                                    <dt className="text-sm md:text-base font-medium text-ink">
                                        {h.day}
                                    </dt>
                                    <dd
                                        className={`text-sm md:text-base text-right ${
                                            h.closed
                                                ? "text-rosegold italic"
                                                : "text-stone2"
                                        }`}
                                    >
                                        {h.time}
                                    </dd>
                                </div>
                            ))}
                        </dl>
                        <p className="mt-6 text-xs tracking-[0.18em] uppercase text-stone2/70">
                            Riceviamo su appuntamento
                        </p>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.1} className="mt-14">
                <div className="border border-linen overflow-hidden">
                    <iframe
                        data-testid="map-iframe"
                        title="Mappa — Moovie Parrucchieri, Via Postumia 166A, Paese (TV)"
                        src={SALON.mapsEmbed}
                        className="w-full h-[380px] md:h-[440px] grayscale contrast-[1.05]"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                    />
                </div>
            </Reveal>
        </div>
    </section>
);

export default Contact;
